import { createWebSocketHandlers } from '@/services/websocketHandlers'

export const createMessageProcessor = (getContext) => {
  const handlers = createWebSocketHandlers()

  // Система подписок на события
  // const eventSubscriptions = new Map();

  return {
    dashboardUpdate: (event) => {
      try {
        const message = JSON.parse(event.data)
        // 1. Основной обработчик команды
        const handler = handlers[message.cmd]
        if (handler) {
          handler(message, getContext())
        }

        // 2. Вызов всех подписичков на это событие
        // const subscribers = eventSubscriptions.get(message.cmd);
        // if (subscribers) {
        //   subscribers.forEach(callback => callback(message, context));
        // }
      }
      catch (error) {
        console.error('Ошибка обработки сообщения:', error)
        throw error // или обрабатываем ошибку здесь
      }
    },
    // Методы для работы с подписками
    // subscribe: (eventType, callback) => {
    //   if (!eventSubscriptions.has(eventType)) {
    //     eventSubscriptions.set(eventType, new Set());
    //   }
    //   eventSubscriptions.get(eventType).add(callback);

    //   return () => this.unsubscribe(eventType, callback);
    // },

    // unsubscribe: (eventType, callback) => {
    //   eventSubscriptions.get(eventType)?.delete(callback);
    // },

    // Методы для управления основными обработчиками
    // addHandler: (command, handler) => {
    //   commandHandlers[command] = handler;
    // },

    // removeHandler: (command) => {
    //   delete commandHandlers[command];
    // }
  }
}
